import { extendTheme } from '@chakra-ui/react';
import '@fontsource/inter';
import { MultiSelectTheme } from 'chakra-multiselect';
import { accordionTheme } from './components/accordionTheme';

const styles = {
	body: {
		height: '100vh',
	},
};

const fonts = {
	heading: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
	body: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
	mono: "'JetBrains Mono', monospace",
};

const config = {
	initialColorMode: 'light',
	useSystemColorMode: false,
};

const colors = {
	teal300: '#4FD1C5',
	blackAlpha50: '#F5F5F5',
	grayAow: '#4A5568',
	warning: '#FFA500',
};

const components = {
	Input: {
		variants: {},
	},
	NumberInput: {
		variants: {},
	},
	Button: {
		variants: {
			teal300: {
				bg: '#4FD1C5',
				color: '#1A202C', // WCAG AA compliant text contrast (9.5:1 ratio)
				_hover: {
					bg: '#38B2AC',
					color: 'white',
				},
			},
			redAow: {
				bg: '#E53E3E',
				color: 'white',
				_hover: {
					bg: '#C53030',
					color: 'white',
				},
			},
			aowSidebar: {
				w: 'full',
				bg: 'gray.600',
				color: 'teal.300',
				_hover: {
					bg: 'gray.500',
				},
			},
		},
	},
	Select: {
		variants: {},
	},

	Heading: {
		baseStyle: {},
		variants: {},
	},
	Checkbox: {
		defaultProps: {
			colorScheme: 'teal',
		},
	},

	Switch: {
		baseStyle: {
			thumb: {
				cursor: 'pointer',
			},
			track: {
				cursor: 'pointer',
			},
		},
	},

	Accordion: accordionTheme,
	MultiSelect: MultiSelectTheme,
};

export const theme = extendTheme({
	config,
	styles,
	components,
	fonts,
	colors,
});
